import React, { useEffect, useState } from "react";
import footerIcon from "../../images/footer-icon-new.png";
import { fetchMessage } from "../../services/api";
import getFontData from "../../common";

interface DisclaimerItem {
  title: string;
  slug: string;
  content: string;
}

const Disclaimer: React.FC = () => {
  const { Contact, Email } = getFontData();
  const [disclaimer, setDisclaimer] = useState<DisclaimerItem | null>(null);

  useEffect(() => {
    const fetchAboutInfo = async () => {
      try {
        const response = await fetchMessage("/api/cms/disclaimer", false);
        setDisclaimer(response.data);
      }
      catch (error) { }
    };
    fetchAboutInfo();
  }, []);

  return (
    <div className="chat-disclaimer">
      <div className="chat-header-row chat-row-container">
        <div className="chat-disclaimer-wrapper">
          {disclaimer && (
            <>
              <h4>{disclaimer?.title}</h4>
              <div className="disclaimer-text" dangerouslySetInnerHTML={{ __html: disclaimer?.content }} />
            </>
          )}
          <div className="footer-wrapper">
            <div className="footer-img">
              <img src={footerIcon} alt="Footer Icon" />
            </div>
            <div>
              <p style={{ textAlign: "center", margin:"auto"}}>
                <a href="https://accreditnet.urac.org/directory/#/accreditation/HWS010005/info" target="_blank" rel="noopener noreferrer">
                  <img
                    className="urclogo"
                    src="https://www.urac.org/wp-content/uploads/2023/01/Accredited001.png"
                    alt="URAC Accredited"
                  />
                </a>
              </p>
              <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif", color: "white", fontSize: "15px" }}>Health Web Site</div>
              <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif", color: "white", fontSize: "15px" }}>06/01/2028</div>
            </div>

            <div className="footer-wrapper">
              <a href={`mailto:${Email}`} className="chat-link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                  <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                </svg>
                {Email}
              </a>
              <a href={`tel:${Contact}`} className="chat-link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
                </svg>
                {Contact}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;